import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Center,
  Heading,
  Text,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { approveClient } from "api/client";
import { useDispatch } from "react-redux";

const ClientApprove = () => {
  const { token } = useParams();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleApproval = async () => {
      try {
        await dispatch(approveClient(token));
        setSuccess(true);
        toast({
          title: "Client approved successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } catch (error) {
        setError(
          error.response?.data?.message || "An unexpected error occurred"
        );
        toast({
          title: "Approval failed",
          description:
            error.response?.data?.message || "An unexpected error occurred",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      handleApproval();
    } else {
      setError("Invalid token");
      setIsLoading(false);
    }
  }, [token, toast]);

  return (
    <Box pt={{ base: "130px", md: "80px" }} px="25px">
      <Center flexDirection="column" py={10}>
        <Heading mb={6}>Client Approval</Heading>

        {isLoading && (
          <Box textAlign="center">
            <Spinner size="xl" mb={4} />
            <Text fontSize="lg">Processing your approval request...</Text>
          </Box>
        )}

        {!isLoading && success && (
          <Box textAlign="center">
            <Text fontSize="xl" color="green.500" mb={4}>
              Client has been successfully approved!
            </Text>
            <Text>
              Thank you for your confirmation. The client now has access to the
              platform.
            </Text>
          </Box>
        )}

        {!isLoading && error && (
          <Box textAlign="center">
            <Text fontSize="xl" color="red.500" mb={4}>
              Approval Failed
            </Text>
            <Text mb={4}>{error}</Text>
            <Text>
              Please contact support if you continue to experience issues.
            </Text>
          </Box>
        )}
      </Center>
    </Box>
  );
};

export default ClientApprove;
